var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgBlogFacebook = function SvgSvgBlogFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.813 10.522V18H6.89v-7.478h3.04l.634-3.438H6.89V5.868c0-1.818.713-2.514 2.555-2.514.574 0 1.034.014 1.301.042V.278C10.245.14 9.014 0 8.304 0 4.546 0 2.812 1.775 2.812 5.604v1.48H.493v3.438h2.32Z",
    fill: "currentColor"
  })));
};
export default SvgSvgBlogFacebook;